import { HttpClient } from 'api/http-client';
class CustomerPortalHTTPClient extends HttpClient {
    getPortalForProject(projectId) {
        return this.get('/customer-portal/resolved', {
            params: {
                project_id: projectId
            }
        });
    }
    getCustomerPortalForProjectForPreview({ portalId, projectId }) {
        return this.post('/customer-portal-builder/resolved-customer-portal', {
            projectId,
            portalId
        });
    }
    getCustomerPortalsInAccount() {
        return this.get('/customer-portal/');
    }
    getCustomerPortalById(portalId) {
        return this.get(`/customer-portal/${portalId}`);
    }
    createCustomerPortal(portal) {
        return this.post('/customer-portal/', portal);
    }
    updateCustomerPortal(portalId, portal) {
        return this.put(`/customer-portal/${portalId}`, portal);
    }
    deleteCustomerPortalById(portalId) {
        return this.delete(`/customer-portal/${portalId}`);
    }
    setDefaultCustomerPortal(portalId) {
        return this.put(`/customer-portal/${portalId}/set-default`);
    }
    getRenderInput(payload) {
        return this.post('/customer-portal-builder/pages/widgets/render-input', payload);
    }
    getDefaultBuildAndRenderInput(payload) {
        return this.post('/customer-portal-builder/pages/widgets/preview-state', payload);
    }
    getDynamicConditionFieldsUsedInPortal(payload) {
        return this.post('/customer-portal-builder/extract-dynamic-condition-fields', payload);
    }
    getCustomerPortalForPreview(payload) {
        return this.post('/customer-portal-builder/preview', payload);
    }
    getInputFields(payload) {
        return this.post('/customer-portal-builder/pages/widgets/build-input-fields', payload);
    }
    getAllowedWidgetsForPageType(payload) {
        return this.post('/customer-portal-builder/pages/allowed-widgets', payload);
    }
    getCustomerPortalProjects(payload) {
        return this.post('/customer-portal-builder/switcher/projects', payload);
    }
    getPortalProjectMapping(projectId) {
        return this.get(`/projects/${projectId}/customer-portal`);
    }
    getBotApiKey(projectId) {
        return this.get(`/customer-portal-builder/bot-api-key/project/${projectId}`);
    }
    getDynamicConditionFields() {
        return this.get('/customer-portal-builder/dynamic-condition-fields');
    }
    getVariableFields(params) {
        return this.post('/customer-portal-builder/variable-fields', params);
    }
    getCpFeatureFlag() {
        return this.get('/customer-portal/enable');
    }
    enableCpFeatureFlag() {
        return this.post('/customer-portal/enable');
    }
    disableCpFeatureFlag() {
        return this.post('/customer-portal/disable');
    }
    getProjectsCount(portalId) {
        return this.post(`/customer-portal/${portalId}/projects/count`);
    }
}
export const CustomerPortalApi = new CustomerPortalHTTPClient();
